import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { Company } from 'src/app/domains/companies/models';
import { CompanyService } from 'src/app/domains/companies/services';
import { UntypedFormControl, Validators } from '@angular/forms';
import { UtilsService } from 'src/app/shared/services/utils/utils.service';

@Component({
  selector: 'gdp-wip-login-popup',
  templateUrl: './wip-login-popup.component.html',
  styleUrls: ['./wip-login-popup.component.scss']
})
export class WipLoginPopupComponent implements OnInit {
  @ViewChild('t') t: NgbTooltip;
  private company: Company;
  public branch: UntypedFormControl;

  constructor(
    private modal: NgbActiveModal,
    private companyService: CompanyService,
    private utils: UtilsService
  ) { }

  ngOnInit(): void {
    this.branch = new UntypedFormControl('', [Validators.required, Validators.minLength(4)]);
  }

  openWIP() {
    this.companyService.openWIPLink(this.company, this.branch.value);
  }

  copyWIP() {
    const link = this.companyService.getWIPLink(this.company, this.branch.value);
    this.utils.copyToClipboard(
      link,
      'text/plain',
      () => {
        this.t.open();
        setTimeout(() => {
          this.t.close();
        }, 2000);
      }
    );
  }

  public close() {
    this.modal.close()
  }

}
